import ET3Div from "../../../../../../core/et3-div";
import { withLiteObserverAndTheme } from "../../../../../../core/et3-enhanced-render";
import Et3TextInput from "../../../../../../core/et3-input/et3-text-input";
import { khattabaConversationParsing } from "../../../../../../helpers/et3-conversation-parse";
import getKhattabat101MessagingStore from "../../../../../../stores/khattabat-stores/messaging-stores/101-messaging-store";
import getKhattabat102MessagingStore from "../../../../../../stores/khattabat-stores/messaging-stores/102-messaging-store";
import getKhattabatSharedMessagingStore from "../../../../../../stores/khattabat-stores/messaging-stores/conversation-messaging-store";

const MessageInputField = withLiteObserverAndTheme<{
  conversationID: string;
}>((props) => {
  const { theme, conversationID } = props;
  const { colors, unitX, unitY } = theme;

  const { messageField, conversationType } =
    getKhattabatSharedMessagingStore(conversationID);
  return (
    <ET3Div
      width={985}
      height={40}
      alignItems={"center"}
      fDirection={"column"}
      style={{
        backgroundColor: colors.all.white,
        borderRadius: 41 * unitX,
        cursor: "text",
        overflow: "hidden"
      }}
      color={""}
      justifyContent={"center"}
      withShadow={false}
      isExtendable={false}
      isScrollable={false}
      onClick={() => {}}
    >
      <Et3TextInput
        size="LARGE"
        withShadow={false}
        placeHolder={"Type Here"}
        icon={"function"}
        label={""}
        style={{
          width: 985 * unitX,
          maxHeight: 40 * unitY
        }}
        value={messageField.get()}
        onChoose={(fieldValue: string) => {
          const parsedText = khattabaConversationParsing(fieldValue);
          getKhattabatSharedMessagingStore(conversationID).setMessageField(
            parsedText
          );
        }}
        onBlur={() => {}}
        type={"text"}
        onEnter={() => {
          conversationType.get() === "102"
            ? getKhattabat102MessagingStore(conversationID).sendMessage()
            : getKhattabat101MessagingStore(conversationID).sendMessage();
        }}
      />
    </ET3Div>
  );
});

export default MessageInputField;
